import { Controller } from "@hotwired/stimulus"

/**
 * Timesheet Row Controller
 * Calculates timesheet duration: (to - from - break)
 * Updates the hours field in real-time
 */
export default class extends Controller {
  static targets = ["from", "to", "break", "hours"]

  connect() {
    // Calculate on initial load
    requestAnimationFrame(() => this.calculate())
  }

  calculate() {
    if (!this.hasFromTarget || !this.hasToTarget || !this.hasHoursTarget) return

    const fromTime = this.parseTime(this.fromTarget.value)
    const toTime = this.parseTime(this.toTarget.value)

    if (fromTime === null || toTime === null) {
      this.hoursTarget.value = ""
      return
    }

    // Calculate duration in hours
    let duration = (toTime - fromTime) / 60 // Convert minutes to hours
    if (duration < 0) duration += 24 // Handle overnight shifts

    // Subtract break time (in minutes)
    if (this.hasBreakTarget && this.breakTarget.value) {
      const breakMinutes = parseFloat(this.breakTarget.value) || 0
      duration -= breakMinutes / 60
    }

    // Round to 2 decimal places
    duration = Math.round(duration * 100) / 100

    // Update the hours field
    if (duration > 0) {
      this.hoursTarget.value = duration.toFixed(2)
    } else {
      this.hoursTarget.value = ""
    }
  }

  /**
   * Parse time string (HH:MM) to minutes since midnight
   */
  parseTime(timeString) {
    if (!timeString) return null

    const parts = timeString.split(":")
    if (parts.length < 2) return null

    const hours = parseInt(parts[0], 10)
    const minutes = parseInt(parts[1], 10)

    if (isNaN(hours) || isNaN(minutes)) return null

    return hours * 60 + minutes
  }
}
